import instance from "@/services/api";

export const bimRoomsAPI = {
  async getList() {
    return await instance().get("/handbook/bim_rooms/read/").then((res) => res?.data);
  },
  async save(data) {
    return await instance().post("/handbook/bim_rooms/save/", data).then((res) => res?.data);
  },
  async importExcel(formData) {
    return await instance()
      .post("/handbook/bim_rooms/import-excel/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res?.data);
  },
};
